import React, {useState} from 'react';
// @ts-ignore
import {Routes, Route, BrowserRouter, Outlet} from "react-router-dom";
import {Button, CssVarsProvider, Sheet, useColorScheme, useTheme} from '@mui/joy';
import AppBar from "./components/Appbar";
import Demo from "./components/Demo";
import HomePage from './pages/Home';
import ContactPage from './pages/Contact';
import NotFoundPage from "./pages/404";
import WorksPage from "./pages/Works";
import Footer from "./components/Footer";
import {ProjectRepository} from "./repository/ProjectRepository";
import ResumePage from "./pages/Resume";
import {SummaryModel} from "./model/summary";
import ExperiencePage from "./pages/Experience";
import WorkPage from "./pages/Work";
import BioPage from "./pages/Bio";

function App() {
    const repo = new ProjectRepository()
    const { mode, setMode } = useColorScheme();
    const [mounted, setMounted] = React.useState(false);
    const[summary, setSummary] = useState<SummaryModel>(new SummaryModel());
    const [error, setError] = useState<boolean>(false);

    React.useEffect(() => {
        repo.getSummary().then(value => {
            if (value.profile.length > 0) {
                setSummary(value)
            }}).catch(reason => setError(true));
        setMounted(true);
    }, []);

    if (!mounted) {
        return null;
    }
    function toggleTheme() {
        setMode(mode === 'dark' ? 'light' : 'dark')

    }
    return (

            <React.Fragment>
                <BrowserRouter>
                    <Routes>
                        <Route path="/" element={<Main onChangeTheme={toggleTheme} summary={summary}/>}>
                            <Route index element={<HomePage/>}/>
                            <Route path="/home" element={<HomePage/>}/>
                            <Route path="/contact" element={<ContactPage/>}/>
                            <Route path="/bio" element={<BioPage/>}/>
                            <Route path="/experience/:key" element={<ExperiencePage/>}/>
                            <Route path="/works" element={<WorksPage/>}/>
                            <Route path="/work/:title" element={<WorkPage/>}/>
                            <Route path="/resume" element={<ResumePage/>}/>
                        </Route>
                        <Route path="*" element={<NotFoundPage/>}/>
                    </Routes>
                </BrowserRouter>
            </React.Fragment>
    );
}

function Main({onChangeTheme, summary} : {onChangeTheme:any,summary:SummaryModel}) {
    return (
        <>
            <AppBar onChangeTheme = {onChangeTheme} summary={summary} />
            <Outlet/>
            <Footer summary={summary}/>
        </>
    )
}

export default App;
